import React from 'react'
import RecursiveContainer from '../RecursiveContainer'
import AdditionalInfoFields from './AdditionalInfoFields'

function CaseCreateFields({ step, field, onChangeUpdate, onBlurValidate, errors, formValues, severitySubStep, severityTitles }) {
const columnMap = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
};
  return (

    <div className='w-full flex flex-col bg-ivory font-plexsans'>
       {step === 2 && (
         <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg bg-[rgba(20,33,61,.04)] mb-4">
           <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(20,33,61,.45)" strokeWidth="2" className="flex-none">
             <rect x="5" y="11" width="14" height="9" rx="2" />
             <path d="M8 11V7a4 4 0 0 1 8 0v4" />
           </svg>
           <span className="text-xs text-[rgba(20,33,61,.55)]">Your answers are private — only your matched attorney sees them.</span>
         </div>
       )}

       {/* Severity rate (step 4) is its own 4-part stepper in the design
           (Physical injury / Economic damages / Non-economic impact /
           Evidence), all still under the overall "Step 4 of 5" — this pill
           row tracks progress through those sub-steps. CreateCaseForm.jsx
           owns severitySubStep and already narrows `field` down to just the
           active sub-step's section. */}
       {step === 4 && severityTitles?.length > 0 && (
         <div className="flex gap-2 mb-8 max-w-[760px] flex-wrap">
           {severityTitles.map((title, idx) => {
             const num = idx + 1;
             const isDone = num < severitySubStep;
             const isActive = num === severitySubStep;
             return (
               <div
                 key={title}
                 className={
                   "px-[18px] py-[9px] rounded-full text-[13.5px] font-semibold whitespace-nowrap font-plexsans " +
                   (isDone
                     ? "bg-tanDark text-ivory"
                     : isActive
                     ? "bg-tan text-ivory"
                     : "bg-[rgba(20,33,61,.06)] text-[rgba(20,33,61,.4)] font-medium")
                 }
               >
                 {isDone ? `✓ ${title}` : `${num} · ${title}`}
               </div>
             );
           })}
         </div>
       )}

       {step === 3 ? (
         <AdditionalInfoFields
           field={field}
           formValues={formValues}
           onChangeUpdate={onChangeUpdate}
           onBlurValidate={onBlurValidate}
           errors={errors}
         />
       ) : (
       field.map((section, sectionIndex) => (
            <div key={section.title || sectionIndex} className="w-full mb-7">
            <div
                className={`
                grid
                grid-cols-1
                gap-6
                ${columnMap[section.columns]}
                `}
            >
                {section.fields.map((field) => (
                    field.doNotShow ? null : (

                <RecursiveContainer
                        key={field.name}
                        onChangeUpdate={onChangeUpdate}
                        field={field}
                        formValues={formValues}
                        errors={errors}
                        onBlurValidate={onBlurValidate}
                    />)
                ))}
            </div>
            </div>
        ))
       )}
    </div>
  )
}

export default CaseCreateFields
